import { type AnyObject, isEvery, omit, PageLoader } from "@sveabank/cc-common";
import { createContext } from "react";
import type { PageHook } from "../types/utility";

export const LoaderContext = createContext<AnyObject>({});

export const withLoader = <T extends AnyObject>(
	loaderHook: PageHook<T>,
	Component: React.ComponentType,
) => {
	const ComponentWithLoader: React.FC = () => {
		const hookData = loaderHook();

		const pageData = omit(hookData, "isLoading");

		LoaderContext.displayName = loaderHook.name;

		if (hookData.isLoading) return <PageLoader />;
		if (!isEvery(pageData)) return null;

		return (
			<LoaderContext.Provider value={pageData}>
				<Component />
			</LoaderContext.Provider>
		);
	};

	return ComponentWithLoader;
};
